import { Component, Input, OnInit, OnDestroy } from "@angular/core";
//import { Subscription } from 'rxjs';

//import {InputTextModule} from 'primeng/inputtext';
import { Table } from "primeng/table";

import { UserService } from "../../../shared/services/user.service";

import { DataService_visitorselector } from "./shared/data.service";

import { wsVPPAdminVisitorSelectorDataParm } from "./shared/wsVPPAdminVisitorSelectorDataParm";
import { wsVPPAdminVisitorSelectorDataInfo } from "./shared/wsVPPAdminVisitorSelectorDataInfo";
import { wsVPPAdminVisitorSelectorVisitorListParm } from "./shared/wsVPPAdminVisitorSelectorVisitorListParm";
import { wsVPPAdminVisitorSelectorVisitorListInfo } from "./shared/wsVPPAdminVisitorSelectorVisitorListInfo";
import { wsVPPAdminVisitorSelectorFacilityInfo } from "./shared/wsVPPAdminVisitorSelectorDataInfo";
import { wsVPPAdminVisitorSelectorStatusInfo } from "./shared/wsVPPAdminVisitorSelectorDataInfo";
import { wsVPPAdminVisitorSelectorTypeInfo } from "./shared/wsVPPAdminVisitorSelectorDataInfo";
import { VPPAdminVisitorSelectorSelectedVisitorInfo } from "./shared/VPPAdminVisitorSelectorSelectedVisitorInfo";
import { wsVPPAdminVisitorSelectorVisitorPhotoInfo } from "./shared/wsVPPAdminVisitorSelectorVisitorPhotoInfo";

import { ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { LocalstorageService } from "../../../shared";

@Component({
	selector: "VPP-VisitorSelector",
	templateUrl: "./visitorselector.component.html",
	styleUrls: ["./visitorselector.component.css"],
})
export class VisitorSelectorComponent implements OnInit, OnDestroy {
	@Input() VisitorLogID: number = -1;
	@ViewChild("mydt") mydt: Table;

	constructor(private dataService: DataService_visitorselector, private userService: UserService, private localService: LocalstorageService) {
		this.dataService.SearchRefreshObservable.subscribe((data) => this.SearchRefresh(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;

	public NameSearch: string = "";
	public LastNameSearch: string = "";
	public FirstNameSearch: string = "";

	public rVisitorPhoto: wsVPPAdminVisitorSelectorVisitorPhotoInfo;
	public Person_Image: string = "";
	public PersonName: string = "";
	public PersonStatusID: number = 0;
	public PersonStatus: string = "";
	public PersonFacilityID: number = -1;

	//	Selector Data
	public rVisitorSelectorData: wsVPPAdminVisitorSelectorDataInfo;

	//	Visitor List
	public lstVisitor: wsVPPAdminVisitorSelectorVisitorListInfo[] = [];
	public SelectedVisitor: wsVPPAdminVisitorSelectorVisitorListInfo;

	//	Facility Selector
	public lstFacility: wsVPPAdminVisitorSelectorFacilityInfo[] = [];
	public SelectedFacility: wsVPPAdminVisitorSelectorFacilityInfo;

	//	Status Selector
	public lstStatus: wsVPPAdminVisitorSelectorStatusInfo[] = [];
	public SelectedStatus: wsVPPAdminVisitorSelectorStatusInfo;

	//	Type Selector
	public lstType: wsVPPAdminVisitorSelectorTypeInfo[] = [];
	public SelectedType: wsVPPAdminVisitorSelectorTypeInfo;

	//	Visitor Counts
	public pagefirst: number = 0;
	public pagerows: number = 5;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//
		//	10.15 Try to select a facility based on the last school that was selected
		//
		var lastSchoolID = -1;
		var lastSchool = this.localService.getItem("SchoolSelector_School");
		if (lastSchool != undefined && lastSchool.SchoolID != undefined) {
			lastSchoolID = lastSchool.SchoolID;
		}

		let parms: wsVPPAdminVisitorSelectorDataParm = {
			UserID: this.user.userID,
			SchoolID: lastSchoolID,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorSelectorDataGet(parms).subscribe((data) => this.VPPAdminVisitorSelectorDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {} //Unsubscribe?

	//-----------------------------------------------------------------------------------------------------
	//
	//	SearchRefresh
	//
	//	Note: Triggered From Event From External Component
	//
	//-----------------------------------------------------------------------------------------------------

	SearchRefresh(data: any) {
		if (data == "Refresh") {
			this.onSearch();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectorDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectorDataGet_Complete(data: any) {
		this.rVisitorSelectorData = data;

		this.lstFacility = this.rVisitorSelectorData.FacilityItems;
		this.lstStatus = this.rVisitorSelectorData.StatusItems;
		this.lstType = this.rVisitorSelectorData.TypeItems;

		//
		//	Add the [- ALL -] to the top of the list
		//
		//	Note: "- ALL" is put in FacilityCD to match the HTML formatting.
		//		this allows it to show with a visual appeal that matches the rest of the items.
		//
		this.lstFacility.unshift({
			FacilityID: -1,
			FacilityCD: "- ALL",
			FacilityName: "",
			Selected: false,
		});

		this.SelectedFacility = this.lstFacility[0];

		for (var z = 0; z < this.lstFacility.length; z++) {
			var next = this.lstFacility[z];

			if (next.Selected == true) {
				this.SelectedFacility = next;
				break;
			}
		}

		//
		//	Add the [- ALL -] to the top of the list
		//
		this.lstStatus.unshift({
			VisitorStatusID: -1,
			VisitorStatusDesc: "- ALL -",
			AllowAdmittance: true,
		});

		this.SelectedStatus = this.lstStatus[0];

		//
		//	Add the [- ALL -] to the top of the list
		//
		this.lstType.unshift({
			VisitorTypeID: -1,
			VisitorTypeDesc: "- ALL -",
		});

		this.SelectedType = this.lstType[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFacilityChange(value) {
		this.onSearch();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {
		this.onSearch();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTypeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onTypeChange(value) {
		this.onSearch();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {
		let parm: VPPAdminVisitorSelectorSelectedVisitorInfo = {
			FacilityID: this.SelectedFacility.FacilityID,
			Visitor_PersonID: this.SelectedVisitor.PersonID,
		};

		this.isBusy = true;
		this.dataService
			.VPPAdminVisitorSelectorGetPhoto(this.SelectedVisitor.PersonID)
			.subscribe((data) => this.VPPAdminVisitorSelectorGetPhoto_Complete(data));

		this.dataService.VisitorSelected(parm);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedFacilityLocation here. We don't unselect when selected.
		//
		this.SelectedVisitor = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectorGetPhoto_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectorGetPhoto_Complete(data: any) {
		this.rVisitorPhoto = data;

		this.Person_Image = this.rVisitorPhoto.Person_Image;
		this.PersonName = this.SelectedVisitor.FirstName + " " + this.SelectedVisitor.LastName;
		this.PersonStatusID = this.SelectedVisitor.VisitorStatusID;
		this.PersonStatus = this.SelectedVisitor.VisitorStatusDesc;
		this.PersonFacilityID = this.SelectedVisitor.FacilityID;

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSearch
	//
	//-----------------------------------------------------------------------------------------------------
	onSearch() {
		var txtSearchValue: string = "";

		this.pagefirst = 0;
		txtSearchValue = this.NameSearch.trim();

		if (txtSearchValue.includes(",")) {
			this.LastNameSearch = txtSearchValue.substring(0, txtSearchValue.indexOf(",")).trim();
			this.FirstNameSearch = txtSearchValue.substring(txtSearchValue.indexOf(",") + 1).trim();
		} else {
			if (txtSearchValue.includes(" ")) {
				this.LastNameSearch = txtSearchValue.substring(txtSearchValue.indexOf(" ") + 1).trim();
				this.FirstNameSearch = txtSearchValue.substring(0, txtSearchValue.indexOf(" ")).trim();
			} else {
				this.LastNameSearch = txtSearchValue; //  Data Entered Is One Word
				this.FirstNameSearch = "";
			}
		}

		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		//
		//	10.15, don't need to type % to see all visitors
		//
		let parms: wsVPPAdminVisitorSelectorVisitorListParm = {
			UserID: this.user.userID,
			FacilityID: this.SelectedFacility.FacilityID,
			VisitorStatusID: this.SelectedStatus.VisitorStatusID,
			VisitorTypeID: this.SelectedType.VisitorTypeID,
			LastName: this.LastNameSearch,
			FirstName: this.FirstNameSearch,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorSelectorSelectList(parms).subscribe((data) => this.VPPAdminVisitorSelectorSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectorSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectorSelectList_Complete(data: any) {
		this.lstVisitor = data;

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "LastName", order: 1 });
		this.mydt.multiSortMeta.push({ field: "FirstName", order: 1 });
		this.mydt.sortMultiple();

		//
		//	Don't Auto Select Visitor On Refresh
		//
		this.SelectedVisitor = null;
		this.Person_Image = "";
		this.PersonName = "";
		this.PersonStatusID = -1;
		this.PersonStatus = "";
		this.PersonFacilityID = -1;

		let parm: VPPAdminVisitorSelectorSelectedVisitorInfo = {
			FacilityID: this.SelectedFacility.FacilityID,
			Visitor_PersonID: -1,
		};

		this.dataService.VisitorSelected(parm);

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
